export default {
    Right: 'right',
    Left: 'left',
}
